import { useUserStore } from "@/stores/user";

export function authGuard(to, from, next) {
  const userStore = useUserStore();

  const requiresAuth = to.meta.requiresAuth !== false;
  if (to.name === "Login" && userStore.isLoggedIn) {
    next("/");
  }

  if (requiresAuth && !userStore.isLoggedIn) {
    next("/login");
  } else {
    next();
  }
}
